// extracted by mini-css-extract-plugin
module.exports = {"hero":"BasicContentErrorPageHeader_hero__FcbMA","search-fade-in":"BasicContentErrorPageHeader_search-fade-in__E6i9_"};